module.exports = __webpack_public_path__ + "static/img/ARCHIE-ROBERTS.e9be832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ARCHIE-ROBERTS.jpg
// module id = 69V8
// module chunks = 0